import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { LogsCount } from '../models/display-log.model';
import { Api } from '../../core/constants/api.constants';
import { ApiOptions } from '../models/api-options.model';

@Injectable({
  providedIn: 'root'
})
export class DisplaysLogsService {
  private apiService = inject(ApiService);

  private path = Api.url.display.logs;
  constructor() {}

  getPath(path?: string): string {
    if (path) {
      return this.getPath() + '/' + path;
    }
    return Api.url.display.base + '/' + this.path.base;
  }

  getDisplayLogsCount(contract?: string, rangeDates?: Date[], display?: string) {
    const param: { [param: string]: any } = {}
    if (contract) {
      param['contract'] = contract
    }
    if (rangeDates && rangeDates.length === 2) {
      const dates = this.formatDates(rangeDates)
      param['startDate'] = dates[0];
      param['endDate'] = dates[1];
    }
    if (display) {
      param['display'] = display
    }
    // console.log('param', param);
    const options: ApiOptions = { params: param };
    // console.log('options', options);
    return this.apiService.get<LogsCount>(this.getPath(this.path.dailyturn), options);
  }

  formatDates(dates: Date[]) {
    const formattedDates = dates.map((date) => {
      return date.toISOString().split('T')[0];
    });
    console.log('format dates', formattedDates);
    return formattedDates;
  }
}
